import {MapService} from 'esri-leaflet';
import {ApplicationConfig} from 'frontend/src/app/classes/application-config';
import L from 'leaflet';
import moment from 'moment';
import {LeafletEagleiSource} from './leaflet-eaglei-source';
import {LeafletMapLayer} from './leaflet-map-layer';

export class LeafletTileSource extends LeafletEagleiSource<L.TileLayer> {
    private failedTiles: number = 0;
    private currentFilters: string;
    private readonly MAX_RETRY_ATTEMPTS = 1;

    private retryTileMap: Map<string, number>;

    protected url: string = `${ApplicationConfig.proxyPrefix}${this.layerInfo.serviceurl}`;

    constructor(layerInfo: LeafletMapLayer) {
        super(layerInfo);
    }

    public fetchImages(style?: string): void {
        this.retryTileMap = new Map<string, number>();

        const leafletOptions: L.TileLayerOptions = {
            // TODO make this configurable
            maxZoom: 22,
            attribution: this.layerInfo.getAttributionLink(),
            noWrap: true,
            bounds: [
                [-90, -180],
                [90, 180],
            ],
        };

        if (this.currentFilters) {
            leafletOptions['CQL_FILTER'] = this.currentFilters;
        }

        if (style) {
            leafletOptions['styles'] = style;
        }

        this.failedTiles = 0;

        const config = {
            ...leafletOptions,
            ...this.layerInfo.getParams(),
        };

        this.source = L.tileLayer(this.url, config);

        this.source.on('loading', () => {
            this.layerInfo.startLoading();
        });

        this.source.on('load', () => {
            const message = this.failedTiles > 0 ? `Failed to load ${this.failedTiles} tiles` : undefined;
            this.layerInfo.endLoading(this.failedTiles !== 0, message);
        });

        this.source.on('tileerror', (event) => {
            this.failedTiles += 1;

            const tileUrl = this.source.getTileUrl(event.coords);
            let retryAttempts = this.retryTileMap.get(tileUrl) || 0;

            if (retryAttempts < this.MAX_RETRY_ATTEMPTS) {
                setTimeout(() => {
                    retryAttempts++;
                    event.tile.src = `${tileUrl}&cache-buster=${moment().valueOf()}`;
                    this.retryTileMap.set(tileUrl, retryAttempts);
                    console.info(`retry attempt #${retryAttempts}`, tileUrl);
                }, 1_000);
            }
        });
    }

    public changeOpacity(opacity: number): void {
        this.source.setOpacity(opacity);
    }
}
